import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {Col, FormGroup, Input, Label, Row} from 'reactstrap';
import _ from 'lodash';
import PropTypes from 'prop-types';
import {Validacao} from "../../../comum/components/Validacao";
import Select from "react-select";
import {createSelectOptions, formatTelefone, getByAtribute} from "../../../../utils/formatar";
import NumberFormat from "react-number-format";
import DatePicker from "react-datepicker";
import moment from "moment";

@inject("store")
@observer
export class DadosMOTSubstituido extends Component {

    static propTypes = {
        controller: PropTypes.object
    };

    constructor(props) {
        super(props);
    }

    render() {
        const solicitacaoSubstituicao = _.get(this.props.controller, "solicitacaoSubstituicao.dadosMot");
        const controller = this.props.controller;
        const razaoOptions = createSelectOptions(this.props.controller.motivosSubstituicao, "nome", "nome");
        const dataInicioSubstituicao = this.props.controller.solicitacaoSubstituicao.dataSolicitacao;
        const razaoSubstituicao = this.props.controller.solicitacaoSubstituicao.razao;
        const tiposSanguineo = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
        const tipoSanguineoOptions = tiposSanguineo.map(tipoSanguineo => {return {value: tipoSanguineo, label: tipoSanguineo}});
        const ufs = ["AC", "AL", "AP", "AM", "BA", "CE", "DF", "ES", "GO", "MA", "MT", "MS", "MG", "PA", "PB", "PR", "PE", "PI", "RJ", "RN", "RS", "RO", "RR", "SC", "SP", "SE", "TO"]
        const ufOptions = ufs.map(uf => {return {value: uf, label: uf}});
        const exibeDadosMOTSubstituicaoDetalhamento = this.props.controller.exibeDadosMOTSubstituicaoDetalhamento;
        return (
            <div>
                <h4>Novo MOT</h4>
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Razão substituição</Label>
                            <Input type="text" value={razaoSubstituicao} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Data início substituição</Label>
                            <Input type="text" value={dataInicioSubstituicao ? moment(dataInicioSubstituicao).format("DD/MM/YYYY") : ""} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
                {exibeDadosMOTSubstituicaoDetalhamento &&
                <Row>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>CPF</Label>
                            <NumberFormat className="form-control" format="###.###.###-##" value={solicitacaoSubstituicao.cpf} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Nome completo</Label>
                            <Input type="text" maxLength={128} value={solicitacaoSubstituicao.nome} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>E-mail</Label>
                            <Input type="text" maxLength={256} value={solicitacaoSubstituicao.email} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Telefone contato</Label>
                            <NumberFormat className="form-control" maxLength={11 + 4} format={(value) => formatTelefone(value)} value={solicitacaoSubstituicao.telefone} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Identidade</Label>
                            <Input type="text" className="form-control" maxLength={16} value={solicitacaoSubstituicao.identidade} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Orgão emissor</Label>
                            <Input type="text" maxLength={32} value={solicitacaoSubstituicao.orgaoEmissor} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Rua</Label>
                            <Input type="text" maxLength={256} value={solicitacaoSubstituicao.endereco.rua} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Número</Label>
                            <Input type="text" maxLength={8} value={solicitacaoSubstituicao.endereco.numero} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Complemento</Label>
                            <Input type="text" maxLength={256} value={solicitacaoSubstituicao.endereco.complemento} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Bairro</Label>
                            <Input type="text" maxLength={128} value={solicitacaoSubstituicao.endereco.bairro} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Cidade</Label>
                            <Input type="text" maxLength={128} value={solicitacaoSubstituicao.endereco.cidade} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>UF</Label>
                            <Input type="text" value={solicitacaoSubstituicao.endereco.uf} readOnly />
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>CEP</Label>
                            <NumberFormat className="form-control" format="#####-###" value={solicitacaoSubstituicao.endereco.cep} readOnly/>
                        </FormGroup>
                    </Col>
                    <Col xs={12} md={6} lg={4}>
                        <FormGroup>
                            <Label>Tipo sanguíneo</Label>
                            <Input type="text" value={solicitacaoSubstituicao.tipoSanguineo} readOnly />
                        </FormGroup>
                    </Col>
                </Row>
                }
            </div>
        )
    }
}